import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"persistent":"","retain-focus":false,"fullscreen":_vm.is_fullscreen},model:{value:(_vm.visible_local),callback:function ($$v) {_vm.visible_local=$$v},expression:"visible_local"}},[_c('ClaimContent',{attrs:{"color":_vm.color,"claimId":_vm.claim_id},on:{"close":function($event){return _vm.onClose()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }